module.exports = __webpack_public_path__ + "img/noLogo.e63ffc34.png";